var _circle, _circle2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_204_4253)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16,
    fill: "#2A2859"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1401 27.5276L23.8753 25.2731M13.8594 27.5276L16.1241 25.2731M19.9997 17.8785V20.5101L21.2646 21.7542M15.388 12.9801C15.059 12.6511 14.6127 12.4663 14.1475 12.4663C13.6822 12.4663 13.2359 12.6511 12.9069 12.9801C12.5779 13.3092 12.3931 13.7554 12.3931 14.2207C12.3931 14.686 12.5779 15.1322 12.9069 15.4612M27.0928 15.4598C27.4218 15.1308 27.6066 14.6845 27.6066 14.2192C27.6066 13.7539 27.4218 13.3077 27.0928 12.9787C26.7638 12.6497 26.3175 12.4648 25.8522 12.4648C25.3869 12.4648 24.9407 12.6497 24.6117 12.9787M26.1401 20.5101C26.1401 23.9013 23.3909 26.6504 19.9997 26.6504C16.6085 26.6504 13.8594 23.9013 13.8594 20.5101C13.8594 17.1189 16.6085 14.3697 19.9997 14.3697C23.3909 14.3697 26.1401 17.1189 26.1401 20.5101Z",
    stroke: "#F7F7FC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_204_4253",
    x1: 8.8,
    y1: 3.46667,
    x2: 33.6,
    y2: 37.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B51D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EBCD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIcon);
export default __webpack_public_path__ + "static/media/timerIcon.068d20b7ca724e96279541a7402092d5.svg";
export { ForwardRef as ReactComponent };